import { useMemo } from 'react';
import { useTranslation } from '@hotjar/translations';
import {
  getTargetedPagesAndTriggers,
  isTargetingAllPages,
} from '../../../common/Wizard/common/targeting';
import type { TargetEntry } from '../../../common/Wizard/common/targeting';

export type TargetingPages = { isValid: boolean; summaryText: string | string[] };

export const useTargetingPages = (
  targeting: TargetEntry[] | undefined,
): TargetingPages | undefined => {
  const { t } = useTranslation('feedback', { keyPrefix: 'survey-wizard-summary' });
  return useMemo(() => {
    if (targeting === undefined) return undefined;
    if (isTargetingAllPages(targeting)) {
      return { summaryText: t('all-pages'), isValid: true };
    }
    const urlRules = getTargetedPagesAndTriggers(targeting);
    if (urlRules.length > 0) {
      return { summaryText: t('specific-pages', { count: urlRules.length }), isValid: true };
    }

    return { summaryText: t('pages-not-set'), isValid: false };
  }, [t, targeting]);
};
